var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manual-build-receipt"},[_c('div',{staticClass:"steps-box"},[_c('Steps',{attrs:{"current":_vm.$store.state.steps}},[_c('Step',{attrs:{"title":_vm.name}}),_vm._v(" "),_c('Step',{attrs:{"title":"填写价格及数量"}}),_vm._v(" "),_c('Step',{attrs:{"title":"订单提交完成","icon":"ios-thumbs-up-outline"}})],1)],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ca4ec62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ManualBuildReceipt.vue
// module id = null
// module chunks = 